'use client';
import React from 'react';
import styles from './Checkbox.module.css';

export interface CheckboxProps {
  id?: string;
  label?: React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  size?: 'small' | 'medium' | 'large';
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  labelClassName = '',
  size = 'medium',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const generatedId = React.useId();
  const checkboxId = id || `checkbox-${generatedId}`;

  return (
      <div className={`${styles.checkboxContainer} ${className} ${styles[size]}`}>
          <div className={styles.inputWrapper}>
              <input
                  type="checkbox"
                  id={checkboxId}
                  checked={checked}
                  onChange={handleChange}
                  disabled={disabled}
                  className={styles.input}
        />
              <div
                  className={`${styles.customCheckbox} ${checked ? styles.checked : ''} ${
            disabled ? styles.disabled : ''
          }`}
                  onClick={handleClick}
        >
                  {checked && (
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={styles.checkIcon}
            >
                      <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
          )}
              </div>
          </div>
          {label && (
          <label
              htmlFor={checkboxId}
              className={`${styles.label} ${labelClassName} ${disabled ? styles.disabledLabel : ''}`}
        >
              {label}
          </label>
      )}
      </div>
  );
};

export default Checkbox;
